import { GET, POST } from "./api.js";

export const faqApi = {
    getFaqs: () => GET("/faqs/"),
    rateFaq: (id, useful) => POST(`/faqs/${id}/rate`, { useful })
};
